import React, { useEffect, useState } from "react";
import { closePopup } from "../../../static/js/Common2";
import closeV2 from "../../../static/image/v2/popup/closeV2.png";
import shopAddBtn from "../../../static/image/v2/shop/shopAddBtn.png";
import shopRemoveBtn from "../../../static/image/v2/shop/shopRemoveBtn.png";
import {addFreeConstApi} from "../../../static/js/service/shopService";

const ShopFreeCostPopup = ({ shopId, minOrderCost, freeCostList }) => {
  const distanceOptions = [1, 1.5, 2, 2.5, 3, 3.5, 4];
  const [selectDistance, setSelectDistance] = useState([]);
  const [freeCosts, setFreeCosts] = useState([]);
  const [deleteList, setDeleteList] = useState([]);

  useEffect(() => {
    const updatedDistances = [...distanceOptions];
    const defaultDistances = updatedDistances.filter(
      (distance) => !freeCostList.some((item) => item.distance === distance)
    );

    setSelectDistance(defaultDistances);
    setFreeCosts(
      freeCostList.length > 0
        ? [...freeCostList]
        : [{ id: 0, distance: 1, minOrderCost }]
    );
  }, [freeCostList]);

  const handleSave = async () => {
    const newEntries = freeCosts.filter((cost) => cost.id === 0).map(({ distance, minOrderCost }) => ({ distance, minOrderCost }));
    const updatedEntries = freeCosts
      .filter((cost) => cost.id !== 0)
      .map(({ id, distance, minOrderCost }) => ({ freeDeliveryCostId: id, distance, minOrderCost }));

    const requestData = {
      shopId,
      ...(newEntries.length > 0 && { addFreeDeliveryCostList: newEntries }),
      ...(updatedEntries.length > 0 && { setFreeDeliveryCostList: updatedEntries }),
      ...(deleteList.length > 0 && { removeFreeDeliveryCostIdList: deleteList }),
    };

    try {
      await addFreeConstApi(requestData);
      window.location.reload();
    } catch (error) {
      console.error(error);
    }
  };

  const handleSelect = (index, value) => {
    const updatedCosts = [...freeCosts];
    updatedCosts[index].distance = value;
    setFreeCosts(updatedCosts);

    const usedDistances = updatedCosts.map((cost) => cost.distance);
    const availableDistances = distanceOptions.filter((opt) => !usedDistances.includes(opt));
    setSelectDistance(availableDistances);
  };

  const handleRemove = (index) => {
    const updatedCosts = [...freeCosts];
    const removedItem = updatedCosts.splice(index, 1)[0];
    setFreeCosts(updatedCosts);

    if (removedItem.id !== 0) {
      setDeleteList((prev) => [...prev, removedItem.id]);
    }

    const usedDistances = updatedCosts.map((cost) => cost.distance);
    const availableDistances = distanceOptions.filter((opt) => !usedDistances.includes(opt));
    setSelectDistance(availableDistances);
  };

  const addFreeCostBox = () => {
    if (freeCosts.length >= 5) {
      alert("최대 5개의 항목만 추가할 수 있습니다.");
      return;
    }

    const newDistance = selectDistance[0] || 0;
    setFreeCosts((prev) => [...prev, { id: 0, distance: newDistance, minOrderCost: 0 }]);

    const usedDistances = [...freeCosts.map((cost) => cost.distance), newDistance];
    const availableDistances = distanceOptions.filter((opt) => !usedDistances.includes(opt));
    setSelectDistance(availableDistances);
  };

  const resetState = () => {
    window.location.reload();
  };

  const renderFreeCostBox = (data, index) => (
    <div key={index} className="lengthCostBox freeCostBox" data-id={data.id}>
      <div
        id={`free${index}`}
        className="popupSelect lengthSelect"
        style={{ zIndex: 200 - index }}
      >
        <div
          className="selectText"
          data-href={`free${index}`}
          data-id={data.distance}
        >
          {data.distance}km
        </div>
        <ul
          id={`free${index}Ul`}
          className="popupSelectFixed lengthCostSelectFixed"
        >
          {selectDistance.map((option, i) => (
            <li
              key={i}
              className="lengthLi"
              onClick={() => handleSelect(index, option)}
            >
              {option}
            </li>
          ))}
        </ul>
      </div>
      <span>km 금액</span>
      <input
        type="number"
        className={`lengthCost freeCost ${index === 0 ? "readOnly" : ""}`}
        name="lengthCost"
        value={data.minOrderCost}
        readOnly={index === 0}
        onChange={(e) => {
          const updatedCosts = [...freeCosts];
          updatedCosts[index].minOrderCost = Number(e.target.value);
          setFreeCosts(updatedCosts);
        }}
      />
      원
      <button
        type="button"
        className="lengthRemoveBtn"
        onClick={() => handleRemove(index)}
      >
        <img src={shopRemoveBtn} alt="삭제" />
      </button>
    </div>
  );

  return (
    <div id="freeCostPopup" className="freeCostPopup popupV2 hide">
      <div className="popupContainer width578">
        <div className="popupTitle">
          <h2>거리별 무료 배달 금액</h2>
          <button
            className="closeBtn stopCloseBtn"
            onClick={() => {
              resetState();
            }}
          >
            <img src={closeV2} alt="닫기" />
          </button>
        </div>
        <div className="popupContent">
          <div className="popupFlexBox popupFlexBox1">
            <div className="flexContent">
              <div className="freeCostListBox">
                {freeCosts.map((item, index) => renderFreeCostBox(item, index))}
              </div>
              <button className="priceAddBtn" onClick={addFreeCostBox}>
                <img src={shopAddBtn} alt="추가" />
              </button>
            </div>
          </div>
        </div>
        <div className="popupBtn">
          <button
            type="button"
            className="closeBtn"
            onClick={() => {
              resetState();
            }}
          >
            취소
          </button>
          <button
            type="button"
            className="freeCostPopupBtn blueBtn"
            onClick={handleSave}
          >
            확인
          </button>
        </div>
      </div>
    </div>
  );
};

export default ShopFreeCostPopup;
